@if (pageReady) {
  <main class="gs-page">
    <div class="gs-page-inner">
      <app-page-header [headerData]="pageHeader"></app-page-header>
      <div class="notification-container">
        <app-notification [pageName]="pageName"></app-notification>
      </div>
      <div class="gs-content-container">
        <p class="header-left">Most changes you make to your account are immediate.</p>
        <div class="bucket-bucket">
          <mat-card class="bucket">
            <mat-card-content class="bucket-content">
              <i class="manage-icon fa-thin fa-fire fa-3x"></i>
              <div class="bucket-info">
                <h2 class="bucket-header">{{ pageLabels.serviceDetailsHeader }}</h2>
                <p class="bucket-text">{{ pageLabels.serviceDetailsDescription }}</p>
                <a
                  [attr.aria-label]="pageData.PlanAria"
                  class="bucket-btn gs-link-btn"
                  [routerLink]="pageData.PlanLink"
                  >{{ pageLabels.editButtonText }}</a
                >
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="bucket">
            <mat-card-content class="bucket-content">
              <i class="manage-icon fa-thin fa-phone fa-3x"></i>
              <div class="bucket-info">
                <h2 class="bucket-header">{{ pageLabels.contactInfoHeader }}</h2>
                <div class="bucket-text">
                  <p>
                    {{ pageLabels.contactEmailLabel }} {{ accountData.Email }}
                    <span class="data-invalid">{{ pageData.EmailUndeliverable ? "Undeliverable" : "" }}</span>
                  </p>
                  <p>
                    {{ pageData.PhoneLabel }}: {{ accountData.Phone }}
                    <span class="data-invalid">{{ pageData.PhoneUnconfirmed ? "Invalid" : "" }}</span>
                  </p>
                  @if (pageData.MorePhoneNumbers) {
                    <p>{{ pageData.MorePhoneNumbers }}</p>
                  }
                </div>
                <a
                  [attr.aria-label]="pageData.ContactAria"
                  class="bucket-btn gs-link-btn"
                  [routerLink]="pageData.ContactLink"
                  >{{ pageLabels.editButtonText }}</a
                >
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="bucket">
            <mat-card-content class="bucket-content">
              <i class="manage-icon fa-thin fa-house fa-3x"></i>
              <div class="bucket-info">
                <h2 class="bucket-header">
                  @if (accountDetail.PrimaryAccountHolder) {
                    {{ pageLabels.mailingAddressLabel }}
                  } @else {
                    {{ pageLabels.primaryUserMailingAddressLabel }}
                  }
                </h2>
                <div class="bucket-text">
                  @if (pageData.HasAddress) {
                    <p>{{ accountData.MailingAddress.Address1 | titlecase }}</p>
                    <p>
                      {{ accountData.MailingAddress.City | titlecase }} {{ accountData.MailingAddress.State }},
                      {{ accountData.MailingAddress.PostalCode }}
                    </p>
                  } @else {
                    @if (accountDetail.PrimaryAccountHolder) {
                      <p>{{ pageLabels.addMailingAddressLabel }}</p>
                    }
                  }
                </div>
                @if (accountDetail.PrimaryAccountHolder) {
                  <a
                    [attr.aria-label]="pageData.MailingAria"
                    class="bucket-btn gs-link-btn"
                    [routerLink]="pageData.MailingLink"
                    >{{ pageData.MailingCta }}</a
                  >
                }
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="bucket">
            <mat-card-content class="bucket-content">
              <i class="manage-icon fa-thin fa-user fa-3x"></i>
              <div class="bucket-info">
                <h2 class="bucket-header">{{ pageLabels.loginInfoHeader }}</h2>
                <div class="bucket-text">
                  <p>{{ pageLabels.usernameLabel }} {{ accountData.UserName | uppercase }}</p>
                  <p>{{ pageLabels.passwordLabel }} <i class="fa-solid fa-lock"></i></p>
                </div>
                <a
                  [attr.aria-label]="pageData.LoginAria"
                  class="bucket-btn gs-link-btn"
                  [routerLink]="pageData.LoginLink"
                  >{{ pageLabels.editButtonText }}</a
                >
              </div>
            </mat-card-content>
          </mat-card>

          @if (
            accountDetail.PrimaryAccountHolder &&
            (accountDetail.CustomerClass === "RES" || accountDetail.CustomerClass === "SMLCOM")
          ) {
            <mat-card class="bucket">
              <mat-card-content class="bucket-content">
                <i class="manage-icon fa-thin fa-bell fa-3x"></i>
                <div class="bucket-info">
                  <h2 class="bucket-header">{{ pageLabels.alertsHeader }}</h2>
                  <div class="bucket-text">
                    <p>{{ pageLabels.alertSectionText }}</p>
                  </div>
                  <a
                    [attr.aria-label]="pageData.AlertsAria"
                    class="gs-link-btn bucket-btn"
                    [routerLink]="pageData.AlertsLink"
                    >{{ pageLabels.editButtonText }}</a
                  >
                </div>
              </mat-card-content>
            </mat-card>
          }

          <mat-card class="bucket">
            <mat-card-content class="bucket-content nickname-content">
              <i class="manage-icon fa-thin fa-id-card-clip fa-3x"></i>
              <div class="bucket-info nickname-info">
                <h2 class="bucket-header nickname-header">{{ pageLabels.nickNameHeaderText }}</h2>
                <div class="bucket-text nickname-form-field">
                  <form [formGroup]="nickNameForm">
                    <mat-form-field appearance="outline" class="nick-name-width">
                      <mat-label>{{ pageLabels.nickNameLabel }}</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="nickName"
                        placeholder=""
                        id="nickName"
                        maxlength="48"
                        aria-labelledby="nickNameInvalidError nickNameInvalidCharError"
                      />
                      @if (nickNameForm.get("nickName")?.hasError("invalidCharacters")) {
                        <mat-error id="nickNameInvalidCharError">{{
                          pageLabels.nickNameSpecialCharactersValidationErrorText
                        }}</mat-error>
                      }
                    </mat-form-field>
                  </form>
                </div>
                <div class="buttons-wrapper">
                  <button
                    id="cancelBtn"
                    type="button"
                    mat-flat-button
                    class="gs-form-button-primary cancel-button"
                    color="primary"
                    (click)="onCancelNickNameClick()"
                  >
                    {{ pageLabels.cancelButtonText }}
                  </button>
                  <button
                    id="updateNickNameBtn"
                    type="button"
                    mat-flat-button
                    class="gs-form-button-primary bucket-btn"
                    color="primary"
                    (click)="saveNickName()"
                  >
                    {{ pageLabels.updateButtonText }}
                  </button>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          @if (
            !accountDetail.PrimaryAccountHolder ||
            !(accountDetail.CustomerClass === "RES" || accountDetail.CustomerClass === "SMLCOM")
          ) {
            <mat-card class="bucket bucket-noborder">
              <mat-card-content class="bucket-content"> </mat-card-content>
            </mat-card>
          }

          @if (accountDetail.CustomerClass === "RES" || accountDetail.CustomerClass === "SMLCOM") {
            <div class="refer-a-friend">
              <mat-card class="refer-a-friend-bucket">
                <mat-card-content class="refer-a-friend-bucket-content">
                  @if (accountDetail.ReferFriendCode === "") {
                    <i class="manage-icon fa-thin fa-user-group-simple fa-3x"></i>
                  }
                  <div class="refer-a-friend-bucket-body">
                    @if (accountDetail.ReferFriendCode !== "") {
                      <h2 class="bucket-header">{{ pageLabels.referAFriendHeader }}</h2>
                      <p>{{ pageLabels.activeReferAFriendProgramText }}</p>
                      <div class="refer-a-friend-form-container">
                        <mat-form-field class="referFriend" appearance="outline" subscriptSizing="dynamic">
                          <input
                            matInput
                            #referFriendCode
                            type="text"
                            [value]="accountDetail.ReferFriendCode"
                            id="referFriendCode"
                            [disabled]="true"
                          />
                          <button
                            class="copy-paste-btn bucket-btn"
                            mat-icon-button
                            matTooltip="Copy"
                            matTooltipPosition="above"
                            matSuffix
                            aria-label="Copy Refer a Friend Code"
                            (keydown.enter)="copyText(referFriendCode.value)"
                            (keydown.space)="copyText(referFriendCode.value)"
                            (click)="copyText(referFriendCode.value)"
                          >
                            <i class="fa-thin fa-copy"></i>
                          </button>
                        </mat-form-field>
                      </div>
                      <a
                        href="javascript:void(0);"
                        class="fb-share-button"
                        (click)="openFB()"
                        aria-label="Share Refer A Friend Code to Facebook"
                        ><i class="fa-brands fa-facebook"></i> {{ pageLabels.shareButtonText }}</a
                      >
                    } @else {
                      <div class="get-referral-code-container">
                        <h2 class="bucket-header">{{ pageLabels.nonActiveReferAFriendProgramText }}</h2>
                        <p>{{ pageLabels.activeReferAFriendProgramText }}</p>
                        <a
                          class="gs-link-btn get-refer-code-btn"
                          role="button"
                          [attr.aria-label]="pageData.RAFLinkAriaLabel"
                          [routerLink]="pageData.RAFLink"
                        >
                          {{ pageData.RAFLinkText }}
                        </a>
                      </div>
                    }
                  </div>
                  <img class="refer-a-friend-img" src="{{ pageLabels.referFriendImage }}" alt="random image alt" />
                </mat-card-content>
              </mat-card>
            </div>
          }
        </div>
        <a
          href="{{ pageLabels.deleteAccountLink.value.data.url }}"
          [attr.aria-label]="pageLabels.deleteAccountLinkAriaLabel"
          ><i class="fa-regular fa-trash-can"></i> {{ pageLabels.deleteAccountLinkText }}</a
        >
      </div>
    </div>
  </main>
}
